import Moment from 'moment';

import {daysOfWeek} from '../components/StaffList/staffHelpers';
import {timesheetActionTypes} from '../actions/actionTypes';

const initialState = {
  count: 0,
  data: [],
  endDate: new Moment()
    .day(6)
    .endOf('day')
    .format('MM-DD-YYYY'),
  error: null,
  newEntries: [],
  pageNumber: 1,
  pageSize: 50,
  savedEntriesData: {
    Data: {},
    EmployeeName: '',
  },
  selected: 'thisWeek',
  selectedDay: 1,
  selectedDayString: 'Monday',
  selectedEndDate: new Moment()
    .day(6)
    .endOf('day')
    .format('MM-DD-YYYY'),
  selectedStartDate: new Moment().day(0).format('MM-DD-YYYY'),
  startDate: new Moment().day(0).format('MM-DD-YYYY'),
};

export default function timesheetsReducer(state = initialState, action) {
  switch (action.type) {
    case timesheetActionTypes.LOAD_TIMESHEET_SUCCESS:
      return {...state, ...action.timesheet};

    case timesheetActionTypes.TIMESHEET_CHANGE_PAGE:
      return {
        ...state,
        pageNumber: action.pageNumber,
        pageSize: action.pageSize,
      };

    case timesheetActionTypes.TIMESHEET_DATE_CHANGE:
      return {
        ...state,
        endDate: action.endDate || state.endDate,
        selected: action.selected || state.selected,
        selectedEndDate: action.selectedEndDate || state.selectedEndDate,
        selectedStartDate: action.selectedStartDate || state.selectedStartDate,
        startDate: action.startDate || state.startDate,
      };

    case timesheetActionTypes.LOAD_EDIT_TIMESHEET_SUCCESS: {
      const data = action.loadedEntriesData;
      const newEntries = daysOfWeek.map(day => {
        const entries = [];

        // if day has no active entries, add blank one to new entries
        if (
          data[day] &&
          (data[day].Data === null ||
            data[day].Data.findIndex(e => e && e.IsActive) === -1)
        ) {
          entries.push({IsActive: true, isNew: true, newId: 101});
        }

        return entries;
      });

      return {...state, savedEntriesData: action.loadedEntriesData, newEntries};
    }

    case timesheetActionTypes.CHANGE_SELECTED_DAY:
      return {
        ...state,
        selectedDay: action.selectedDay,
        selectedDayString: daysOfWeek[action.selectedDay],
      };

    case timesheetActionTypes.NEW_TIME_ENTRY_CREATED: {
      const newEntries = [...state.newEntries];
      const dayEntries = [...newEntries[state.selectedDay]];
      const lastId =
        dayEntries.length > 0 ? dayEntries[dayEntries.length - 1].newId : 101;

      dayEntries.push({IsActive: true, isNew: true, newId: lastId + 1});
      newEntries[state.selectedDay] = dayEntries;

      return {...state, newEntries};
    }

    case timesheetActionTypes.REMOVE_NEW_TIME_ENTRY: {
      const newEntries = [...state.newEntries];
      const dayEntries = [...newEntries[state.selectedDay]];
      const indexInNewEntryArray = dayEntries.findIndex(
        e => e && e.newId === action.entry.newId,
      );

      dayEntries.splice(indexInNewEntryArray, 1);
      newEntries[state.selectedDay] = dayEntries;

      return {...state, newEntries};
    }

    case timesheetActionTypes.UPDATE_NEW_ENTRY: {
      const newEntries = [...state.newEntries];
      const dayEntries = [...newEntries[state.selectedDay]];
      const indexInNewEntryArray = dayEntries.findIndex(
        e => e && e.newId === action.entry.newId,
      );

      if (indexInNewEntryArray !== -1) {
        const entry = {
          ...dayEntries[indexInNewEntryArray],
          ...action.newValues,
        };

        dayEntries[indexInNewEntryArray] = entry;
        newEntries[state.selectedDay] = dayEntries;

        return {...state, newEntries};
      }

      return {...state, error: 'Error updating time entry'};
    }

    case timesheetActionTypes.UPDATE_ENTRY: {
      const savedEntriesData = {...state.savedEntriesData};
      const dayEntries = [...savedEntriesData[state.selectedDayString].Data];
      const savedIndex = dayEntries.findIndex(
        e => e && e.Id === action.entry.Id,
      );
      const entry = Object.assign({}, dayEntries[savedIndex], action.newValues);

      dayEntries[savedIndex] = entry;
      savedEntriesData[state.selectedDayString].Data = dayEntries;

      return {...state, savedEntriesData};
    }

    case timesheetActionTypes.SAVE_NEW_ENTRY_SUCCESS: {
      const {newEntry} = action;
      const savedEntriesData = {...state.savedEntriesData};
      const dayEntries = savedEntriesData[state.selectedDayString].Data
        ? [...savedEntriesData[state.selectedDayString].Data]
        : [];

      newEntry.IsActive = 1;
      dayEntries.push(newEntry);
      savedEntriesData[state.selectedDayString].Data = dayEntries;

      const newEntries = [...state.newEntries];

      newEntries[state.selectedDay] = [];

      return {...state, savedEntriesData, newEntries};
    }

    case timesheetActionTypes.SAVE_CHANGES_SUCCESS: {
      const savedEntriesData = {...state.savedEntriesData};
      const dayEntries = [...savedEntriesData[state.selectedDayString].Data];
      const savedIndex = dayEntries.findIndex(
        e => e && e.Id === action.entry.Id,
      );

      dayEntries[savedIndex] = Object.assign({}, action.entry);
      savedEntriesData[state.selectedDayString].Data = dayEntries;

      return {...state, savedEntriesData};
    }

    case timesheetActionTypes.REMOVE_TIME_ENTRY: {
      const savedEntriesData = {...state.savedEntriesData};
      const dayEntries = [...savedEntriesData[state.selectedDayString].Data];
      const savedIndex = dayEntries.findIndex(
        e => e && e.Id === action.entry.Id,
      );
      const entry = {...dayEntries[savedIndex]};

      entry.needsDelete = true;
      dayEntries[savedIndex] = entry;
      savedEntriesData[state.selectedDayString].Data = dayEntries;

      return {...state, savedEntriesData};
    }

    case timesheetActionTypes.DELETE_TIME_ENTRY_SUCCESS: {
      const savedEntriesData = {...state.savedEntriesData};

      if (savedEntriesData[state.selectedDayString].Data) {
        const dayEntries = [...savedEntriesData[state.selectedDayString].Data];
        const savedIndex = dayEntries.findIndex(
          e => e && e.Id === action.entryId,
        );

        if (savedIndex !== -1) {
          const entry = {...dayEntries[savedIndex]};

          entry.IsActive = false;
          dayEntries[savedIndex] = entry;
        }

        savedEntriesData[state.selectedDayString].Data = dayEntries;
      }

      return {...state, savedEntriesData};
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/timesheetsReducer.js